<template>
  <div class="recycle-content" v-loading="loading">
    <div class="recycle-content-top clear">
      <div class="recycle-title fl">回收站</div>
      <div class="fr">
        <div class="recycle-right">
          <span class="all" style="padding-top: 5px;"
            ><el-checkbox v-model="checked" @change="changevalue"></el-checkbox
            ><span class="select-all">全部选中</span>
          </span>
          <div class="all-withdraw cursor" @click="withdraw">
            <div class="withdraw-icon"></div>
            <div class="withdraw-text">批量撤回</div>
          </div>
          <div class="all-delete cursor" @click="batchDelete">
            <div class="delete-icon"></div>
            <div class="delete-text">批量删除</div>
          </div>
        </div>
        <!-- <span class="all-delete" @click="batchDelete">
          <span class="iconfont delete-icon">&#xe6ca;</span>
          <span>批量删除</span>
        </span> -->
      </div>
    </div>
    <div v-if="rowCount > 0" class="recycle-list">
      <el-row :gutter="20" style="margin-top: 2px;margin-left: -8px">
        <el-col :span="4.8" v-for="item in list" :key="item.Id">
          <RecycleCard
            :item="item"
            @deleteDoc="deleteDoc"
            @withdrawdoc="withdrawdoc"
            style="margin-bottom:20px"
          ></RecycleCard>
        </el-col>
      </el-row>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="rowCount"
          :current-page="pageIndex"
          :page-size="pageSize"
          @current-change="getList"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
    <div class="nodata" v-if="rowCount <= 0">暂无数据</div>
  </div>
</template>

<script>
import RecycleCard from "../components/share/RecycleCard";
import { mapActions } from "vuex";
export default {
  components: { RecycleCard },
  data() {
    return {
      loading: false,
      pageIndex: 1,
      pageSize: 18,
      rowCount: 0,
      list: [],
      getCheck: false
    };
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "recycle-list", -12, "class");
      }
    }
  },
  computed: {
    docUpdate: {
      get() {
        return this.$store.state.material.docUpdate;
      },
      set(val) {
        this.$store.state.material.docUpdate = val;
      }
    },
    // checked() {
    //   if (this.list.length > 0) {
    //     var trueList = this.list.filter((m) => m.ischecked == true);
    //     return trueList.length == this.list.length;
    //   } else {
    //     return false;
    //   }
    // },
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      }
    },
    checked: {
      get() {
        if (this.list != null && this.list.length > 0) {
          var trueList = this.list.filter(m => m.ischecked === true);
          return trueList.length === this.list.length;
        } else {
          return false;
        }
      },
      set() {
        if (this.list != null && this.list.length > 0) {
          var trueList = this.list.filter(m => m.ischecked === true);
          return trueList.length === this.list.length;
        } else {
          return false;
        }
      }
    }
  },

  methods: {
    ...mapActions("api", ["ARecycle", "ADocDel", "ADocRecovery"]),
    changevalue(val) {
      if (this.list != null && this.list.length > 0) {
        this.list.forEach(m => (m.ischecked = val));
      }
    },
    //单个撤回
    async withdrawdoc(docId) {
      var result = await this.ADocRecovery({ DocIdList: docId });
      if (result.errorCode === 0) {
        this.list = this.list.filter(m => m.docId != docId);
        this.rowCount = this.rowCount - 1;
        this.$message({
          message: "撤回成功",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          showClose: true,
          message: "撤回失败了",
          type: "error"
        });
      }
      // this.list.forEach((m) => (m.ischecked = val));
    },
    //批量撤回
    async withdraw() {
      if (this.list.length == 0) {
        this.$message({
          showClose: true,
          message: "没有数据可以撤回",
          type: "warning"
        });
        return;
      }
      var trueList = [];
      this.list.forEach(m => {
        if (m.ischecked == true) {
          trueList.push(m.docId);
        }
      });
      if (trueList.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择需要撤回的文章",
          type: "warning"
        });
        return;
      }
      var result = await this.ADocRecovery({ DocIdList: trueList.join("|") });
      if (result.errorCode === 0) {
        this.list = this.list.filter(m => {
          return !trueList.includes(m.docId);
        });
        this.rowCount = this.rowCount - trueList.length;
        this.$message({
          message: "撤回成功",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          showClose: true,
          message: "撤回失败了",
          type: "error"
        });
      }
    },
    //刪除本地docid
    deleteLocalDocId(docId, type) {
      const getArticle = localStorage.getItem("lastEditorContent");
      if (getArticle) {
        let insertDoc = JSON.parse(getArticle);
        if (type) {
          if (insertDoc.docId === docId) {
            insertDoc.docId = "";
            this.setLastEditContent(insertDoc);
          }
        } else {
          docId.forEach(m => {
            if (m && m !== "undefined") {
              if (insertDoc.docId === m) {
                insertDoc.docId = "";
                this.setLastEditContent(insertDoc);
              }
            }
          });
        }
      }
    },
    //单个删除
    async deleteDoc(docId) {
      var result = await this.ADocDel({ docIdList: docId, IsPhysicsDel: 1 });
      if (result.errorCode === 0) {
        this.docUpdate = true;
        this.deleteLocalDocId(docId, true);
        this.list = this.list.filter(m => m.docId !== docId);
        this.rowCount--;
        this.$message({
          message: "删除成功",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          showClose: true,
          message: "删除失败了",
          type: "error"
        });
      }
    },
    //批量删除
    async batchDelete() {
      if (this.list.length === 0) {
        this.$message({
          showClose: true,
          message: "没有数据可以删除",
          type: "warning"
        });
        return;
      }
      var trueList = [];
      this.list.forEach(m => {
        if (m.ischecked === true) {
          trueList.push(m.docId);
        }
      });
      if (trueList.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择需要删除的文章",
          type: "warning"
        });
        return;
      }
      var result = await this.ADocDel({
        DocIdList: trueList.join("|"),
        IsPhysicsDel: 1
      });
      if (result.errorCode === 0) {
        this.deleteLocalDocId(trueList, false);
        this.list = this.list.filter(m => {
          return !trueList.includes(m.docId);
        });
        this.rowCount = this.rowCount - trueList.length;
        this.$message({
          message: "删除成功",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          showClose: true,
          message: "删除失败了",
          type: "error"
        });
      }
    },
    async getList(pageIndex) {
      this.loading = true;
      var _this = this;
      var result = await this.ARecycle({
        pageIndex: pageIndex,
        pageSize: _this.pageSize
      });
      this.loading = false;
      var list = result.data.dataSource;
      list.forEach(value => {
        value["ischecked"] = false;
      });
      this.list = list;
      this.rowCount = result.data.rowCount;
    }
  },
  mounted() {
    this.getList(1);
    let getid = setInterval(() => {
      let getBox = document.getElementsByClassName("recycle-list")[0];
      if (getBox) {
        clearInterval(getid);
        this.getHotLineHeight(this.contentHeight, "recycle-list", -12, "class");
      }
    }, 500);
  }
};
</script>

<style lang="less" scoped>
@import "../assets/style/color";
@import "../assets/style/config";
@import "../assets/style/mixin";
.recycle-content {
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 4px;
  // 标题
  .recycle-title {
    height: 16px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(102, 102, 102, 1);
    line-height: 36px;
  }
  .recycle-content-top {
    padding-bottom: 20px;
  }
  .select-all {
    height: 12px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    margin-left: 5px;
  }
  .recycle-right {
    display: flex;
    .all-withdraw {
      margin-left: 8px;
      height: 28px;
      border: 1px solid rgba(196, 196, 196, 1);
      border-radius: 14px;
      display: flex;
      align-items: center;
      padding: 2px 5px;
      .withdraw-icon {
        .icon("../assets/image/document/recycle.png");
      }
      .withdraw-text {
        .text();
      }
    }
    .all-delete {
      margin-left: 8px;
      height: 28px;
      border: 1px solid rgba(196, 196, 196, 1);
      border-radius: 14px;
      display: flex;
      align-items: center;
      padding: 2px 5px;
      .delete-icon {
        .icon("../assets/image/document/delete.png");
      }
      .delete-text {
        .text();
      }
    }
    .text {
      height: 12px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
    }
    .icon(@url) {
      width: 12px;
      height: 12px;
      background-image: url(@url);
      background-size: 12px 12px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      line-height: 36px;
      margin-right: 2px;
    }
  }
  .recycle-list {
    overflow: auto;
  }
}

// .all {
//   line-height: 25px;
//   color: @color999;
//   height: 25px;
//   padding: 0 7px;

//   font-size: 14px;
//   margin-left: 10px;
// }
// .all-withdraw {
//   line-height: 25px;
//   color: @color999;
//   height: 25px;
//   border-radius: 20px;
//   border: 1px solid #c5c8cb;
//   padding: 0 7px;
//   cursor: pointer;
//   font-size: 14px;
//   margin-left: 10px;
// }
// .all-withdraw .withdraw-icon {
//   color: green;
//   font-size: 12px;
// }
// .all-delete {
//   line-height: 25px;
//   color: @color999;
//   height: 25px;
//   border-radius: 20px;
//   border: 1px solid #c5c8cb;
//   padding: 0 7px;
//   cursor: pointer;
//   font-size: 14px;
//   margin-left: 10px;
// }
// .all-delete .delete-icon {
//   color: red !important;
//   font-size: 14px;
// }
.page {
  margin: 10px;
}
</style>
